<template>
  <div class="header-right">
    <!--user-->
    <div v-show="isShowUserNavRright" class="header-right__user">
      <Notification />
      <HeaderData />
    </div>
    <!--guest-->
    <div v-show="isShowGuestNavRight" class="header-right__guest">
      <RegAuthSocial
        :size="{ default: 's', 'mobile-md': 'm', 'tablet-album': 'l' }"
        class="header-right__social"
        header-style  
        :social-list="socialList"
      />
      <BaseLogin class="header-right__login" :size="{ default: 's', 'mobile-md': 'm', 'tablet-album': 'l' }" data-id="header-login-click" />
      <BaseRegisterAnimation
        class="header-right__register"
        :to="$paths.registration"
        :size="{ default: 's', 'mobile-md': 'm', 'tablet-album': 'l' }"
        v-bind="$device.isDesktop ? {'data-id': 'header-register-click'} : {}"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
/** Components */
import BaseLogin from '@/components/Base/Login'
import BaseRegisterAnimation from '@/components/Base/RegisterAnimation'
import RegAuthSocial from '@/components/RegAuthSocial'
import HeaderData from '~/components/App/AppHeader/HeaderData'
import Notification from '~/components/App/AppHeader/Notification'

export default {
  name: 'HeaderRight',
  components: {
    Notification,
    HeaderData,
    BaseRegisterAnimation, RegAuthSocial, BaseLogin,
  },
  data() {
    return {
      socialList: [
        { social: 'google', icon: 'google-colored', id: 'header-google-click' },
        // { social: 'apple', icon: 'apple', id: 'header-apple-click' },
      ],
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'isUserLoaded']),
    ...mapGetters('userMessages', ['get_userMessages']),
    isShowUserNavRright() {
      if (process.server) return false
      return this.isUserLoaded && this.isLoggedIn && !this.get_userMessages.isLoading
    },
    isShowGuestNavRight() {
      if (process.server) return false
      return !this.isLoggedIn
    },
  },
}
</script>

<style lang="scss" scoped>
.header-right {
  &__or, &__login {
    display: none;
    @include media (tablet) {
      display: flex;
    }
  }
  &__social {
    display: none;
    @include media (tablet-album) {
      display: flex;
      margin-right: var(--spaces-s);
    }
  }
  &__user, &__guest {
    display: flex;
    align-items: center;
    gap: var(--spaces-s);
  }
}
.search-icon {
  margin-right: var(--spaces-s);
  @include media(new-tablet) {
    display: none;
  }
}
</style>
